// extracted by mini-css-extract-plugin
export default {"projectCardBackground":"DemoProjects_projectCardBackground__mxXzi","projectCard":"DemoProjects_projectCard__VedXv"};